<div class="hx-loader">
  <div *ngIf="!length && isLoading" class="hx-loader__wrap">
    <div class="hx-loader__spinner"></div>
  </div>

  <h4 class="hx-loader__title" *ngIf="!length && !isLoading">
    {{ 'hx.hx-loader.noData' | transloco }}
  </h4>
</div>
